import { Box } from '@material-ui/core';
import { autobind } from 'core-decorators';
import { reverse } from 'core/urls';
import { camelize } from 'core/utils';
import userQuery from 'graphql/queries/user.gql';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { graphql } from 'react-apollo';
import { NavLink } from 'react-router-dom';
import styles from './styles.css';
@graphql(userQuery, {name: 'userData'})
@autobind
export default class NewOptionsSidebar extends Component {
    static propTypes = {
        links: PropTypes.array.isRequired,
        userType: PropTypes.string,
        refundType: PropTypes.string,
        action: PropTypes.string,
    };

    static defaultProps = {
        action: 'create',
    }

    getLinks() {
        const texts = {
            dealerCrops: {
                title: <p>Pedido de Bolsas</p>,
                subtitle: <p>Solicitá tus bolsas para el Campo Líder</p>,
            },
            multiplierCrops: {
                title: <p>Selección de Cultivo</p>,
                subtitle: <p>Informá el cultivo que vas a sembrar</p>,
            },
            dealerRefund: {
                title: <p>Presupuesto de Jornada</p>,
                subtitle: <p>Para autorización de gastos</p>,
            },
            multiplierRefund: {
                title: <p>Solicitud de Jornada</p>,
                subtitle: <p>Solicitá la fecha para la charla</p>,
            },
            kits: {
                title: <p>Invitaciones y Kits</p>,
                subtitle: <p>Hacé el pedido de invitación y kits<br />para convocar y recibir a tus invitados</p>,
            },
            bags: {
                title: <p>Pedido de Bolsas</p>,
                subtitle: <p>Solicitá tus bolsas para el lado a lado</p>,
            },
            clTrialSigns: {
                title: <p>Pedido de Carteles</p>,
                subtitle: <p>Solicitá tus carteles de ensayo</p>,
            },
            llTrialSigns: {
                title: <p>Pedido de Carteles</p>,
                subtitle: <p>Solicitá tus carteles de lado a lado</p>,
            },
        };

        return this.props.links
            .filter(link => {
                const orderCategory = camelize([this.props.refundType, this.props.userType, link]);
                return Boolean(this.props.userData.user.permissions[orderCategory]);
            })
            .map(link => {
                let text = texts[link];
                if (!text) text = texts[camelize([this.props.refundType, link])];
                if (!text) text = texts[camelize([this.props.userType, link])];
                return {
                    ...text,
                    url: reverse(camelize([this.props.refundType, this.props.userType, link, this.props.action])),
                };
            });
    }

    render() {
        if (this.props.userData.loading) return null;

        return (
            <Box display='flex' sx={{p: 0.5, justifyContent:'space-between', boxShadow:'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;', borderRadius: 16, background:'white', mt: -8, postion:'absolute', margin:'auto', width: '100%'}} gridRowGap={4}>
                {this.getLinks().map(link => (
                        <NavLink
                            to={link.url}
                            key={link.url}
                            className={styles.option}
                            activeClassName={styles.active}
                            >
                            {link.title}
                        </NavLink>
                ))}
            </Box>
        );
    }
}



// WEBPACK FOOTER //
// ./components/new-options-sidebar/index.js